import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 84.477 73.917',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="seedling-solid"
      className="icon"
      d="M10.56,42.56H0A36.961,36.961,0,0,0,36.959,79.518v23.759a2.648,2.648,0,0,0,2.64,2.64h5.28a2.648,2.648,0,0,0,2.64-2.64V79.518A36.961,36.961,0,0,0,10.56,42.56ZM73.917,32A36.928,36.928,0,0,0,41.628,51.007a42.3,42.3,0,0,1,9.735,17.753A36.97,36.97,0,0,0,84.477,32Z"
      transform="translate(0 -32)"
      fill={fill}
    />
  </svg>
);

export default SVG;
